import t from "../../../../helpers/t";
import { _ } from "../../../../../../vendor";
import { FormatHelper } from "../../../../../utils";
import { getApiHost } from "../../../../../Sync";
import InboomaBaseView from "../../../../../views/InboomaBaseView";
import React from "react";
import { getDocHandler } from "../../../../../utils/HelperOld";

export const getOrderUsername = (order) => {
  if (
    typeof order !== "undefined" &&
    order !== null &&
    typeof order.id !== "undefined" &&
    order.id !== null
  ) {
    if (typeof order.user === "undefined" || order.user === null) {
      return t("customer_removed");
    } else {
      const user = order.user;
      if (
        (user.first_name === undefined || user.first_name == null || user.first_name == "") &&
        (user.last_name === undefined || user.last_name == null || user.last_name == "")
      ) {
        return (
          user.customer_nbr + (user.deleted !== null ? " (" + t("customer_removed") + ")" : "")
        );
      }
      return (
        user.first_name +
        " " +
        user.last_name +
        (user.deleted !== null ? " (" + t("customer_removed") + ")" : "")
      );
    }
  } else {
    return "";
  }
};
const getReservationOrderUsername = (reserv) => {
  if (
    typeof reserv.order !== "undefined" &&
    reserv.order !== null &&
    typeof reserv.order.id !== "undefined" &&
    reserv.order.id !== null
  ) {
    getOrderUsername(reserv.order);
  } else {
    return "";
  }
};

export const getOrderUserLink = (order, returnPath) => {
  if (
    typeof order !== "undefined" &&
    order !== null &&
    typeof order.id !== "undefined" &&
    order.id !== null
  ) {
    if (typeof order.user === "undefined" || order.user === null) {
      return "#";
    } else {
      return "users/" + order.user.id + "?path=" + btoa(encodeURI(returnPath));
    }
  }
  return "#";
};

export const printContingentsAmountList = (order, hasFormData = false) => {
  let r = " ";
  let _description = "";
  let amountPerContingent = {},
    contingents = {};
  if (typeof order.reservations === "undefined") {
    return r;
  }

  order.reservations.map((reservation) => {
    if (typeof reservation.contingents[0] === "undefined") {
      return r;
    }

    if (typeof reservation.contingents[0] != "undefined") {
      if (reservation.contingents[0].resourcetype_id == 3 && reservation.checkins.length >= 1) {
        if (reservation.checkins[0] !== "undefined") {
          if (
            reservation.checkins[0].resource !== null &&
            reservation.checkins[0].resource !== "null"
          ) {
            _description = t("app_order_bike_tour_${a}", { a: reservation.contingents[0].name });
          } else {
            if (
              reservation.contingents[0].deleted !== null &&
              reservation.contingents[0].deleted !== ""
            ) {
              _description = t("app_order_bike_tour_min_${a}", {
                a: reservation.contingents[0].name + ", " + t("contingent_removed"),
              });
            } else {
              _description = t("app_order_bike_tour_${a}", { a: t("deleted_resource") }); // OR: Selection of resource in app has not yet been done
            }
          }
        }
      }
    }
    if (_description !== "") {
      return _description;
    }

    if (
      typeof reservation.contingents_reservations !== "undefined" &&
      reservation.contingents_reservations.length >= 1
    ) {
      // Client-7 reservations (where reservation.contingents_reservations holds the acutal amount,
      // however reservation.contingents has the contingent information)

      _.each(reservation.contingents_reservations, function (contingent) {
        // Get amount per contingent
        let full_contingent = _.filter(reservation.contingents, function (cont) {
          return Number(cont.id) === Number(contingent.contingent_id);
        })[0];
        if (typeof full_contingent !== "undefined") {
          if (
            typeof full_contingent.deleted !== "undefined" &&
            full_contingent.deleted !== null &&
            full_contingent.deleted !== ""
          ) {
            full_contingent.contingentDeleted =
              " (" + t("removed_${a}", { a: t("contingent") }) + ")";
          }
          full_contingent.size = FormatHelper.formatContingentTags(full_contingent.tags);
          if (typeof full_contingent.size === "undefined") {
            full_contingent.size = "";
          }
          if (typeof full_contingent.contingentDeleted === "undefined") {
            full_contingent.contingentDeleted = "";
          }
          if (
            typeof amountPerContingent[
              full_contingent.name + full_contingent.size + full_contingent.contingentDeleted
            ] === "undefined"
          ) {
            amountPerContingent[
              full_contingent.name + full_contingent.size + full_contingent.contingentDeleted
            ] = contingent.amount;
          } else {
            amountPerContingent[
              full_contingent.name + full_contingent.size + full_contingent.contingentDeleted
            ] += contingent.amount;
          }

          contingents[
            full_contingent.name + full_contingent.size + full_contingent.contingentDeleted
          ] = full_contingent;
        }
      });
    }
  });

  _.each(amountPerContingent, function (amount, name) {
    // Get contingent data from contingents array

    if (typeof contingents !== "undefined" && typeof contingents[name] !== "undefined") {
      r +=
        (r !== " " ? ", " : "") +
        name +
        contingents[name].size +
        contingents[name].contingentDeleted +
        " x " +
        amount;
    }
  });
  return r;
};

export const getPayStatus = (order) => {
  if (
    typeof order !== "undefined" &&
    order !== null &&
    typeof order.id !== "undefined" &&
    order.id !== null
  ) {
    if (order.paid === 0) {
      if (order.price > 0 && order.price < order.paid) {
        return t("open");
      } else {
        return "";
      }
    } else {
      return t("paid");
    }
  }
};

export const getStatusSelect = (reserv) => {
  let status = reserv.status;
  let stati = [
    {
      text: t("requested", null, "capital"),
      value: "requested",
      disabled: "",
      selected: status === "requested",
    },
    {
      text: t("confirmed", null, "capital"),
      value: "confirmed",
      disabled: "",
      selected: status === "confirmed",
    },
  ];
  if (
    status === "booking_process" ||
    status === "inprogress" ||
    status === "confirmed" ||
    status === "completed"
  ) {
    stati.push({
      text: t("completed", null, "capital"),
      value: "completed",
      disabled: "",
      selected: status === "completed",
    });
    stati.push({
      text: t("inprogress", null, "capital"),
      value: "inprogress",
      disabled: "",
      selected: status === "inprogress",
    });
  }
  stati.push({
    text: t("cancelled", null, "capital"),
    value: "cancelled",
    disabled: "",
    selected: status === "cancelled",
  });
  return stati;
};

export const getOrderStatusSelect = (order) => {
  let status = order.status;
  let stati = [
    {
      text: t("requested", null, "capital"),
      value: "requested",
      disabled: "",
      selected: status === "requested",
    },
    {
      text: t("confirmed", null, "capital"),
      value: "confirmed",
      disabled: "",
      selected: status === "confirmed",
    },
    {
      text: t("authorized", null, "capital"),
      value: "authorized",
      disabled: "disabled",
      selected: status === "authorized",
    },
    {
      text: t("payment_pending", null, "capital"),
      value: "pending",
      disabled: "",
      selected: status === "pending",
    },
  ];
  if (status == "booking_process" || status == "inprogress" || status == "completed") {
    if (status == "booking_process" || status == "inprogress") {
      stati.push({
        text: t(props._exchangeLabel("inprogress"), null, "capital"),
        value: "inprogress",
        disabled: "",
        selected: status == "booking_process" || status == "inprogress",
      });
    }
  }
  //stati.push({text: t('completed',null,'capital'), value: 'completed', disabled: "", selected: (status==='completed')})
  stati.push({
    text: t("paid", null, "capital"),
    value: "paid",
    disabled: "",
    selected: status === "paid",
  });
  stati.push({
    text: t("cancelled", null, "capital"),
    value: "cancelled",
    disabled: "",
    selected: status === "cancelled",
  });
  return stati;
};

export const _printRentalContract = (reserv) => {
  getDocHandler(
    "/rental_contract/" + reserv.id,
    "GET",
    "application/json",
    t("reservation") + "-" + reserv.order.order_nbr + ".pdf",
    "",
    reserv.id,
  );
  /*const ref = getApiHost().slice(0, -4) + '/rental_contract/' + id;
    window.open(ref, '_blank');*/
};

export const _printCheckin = (id) => {
  setCheckoutReservation(id);
  setCheckout(true);
};

export const _printRentalContractDelivery = (order) => {
  getDocHandler(
    "/ticket/" + order.id,
    "GET",
    "application/json",
    t("reservation") + "-" + order.order_nbr + ".pdf",
    "",
    order.id,
  );
  /* const ref = getApiHost().slice(0, -4) +'/ticket/' + id;
    window.open(ref, '_blank');*/
};

export const getState = (reservation) => {
  if (reservation.checkins[0].status !== "cancelled" && reservation.checkins[0].checkout === null) {
    return t(props._exchangeLabel(reservation.checkins[0].status));
  } else {
    return t("checkout_finished");
  }
};

export const getStateClasses = (reservation) => {
  if (reservation.checkins[0].status !== "cancelled" && reservation.checkins[0].checkout === null) {
    return "";
  } else {
    return "checkout_completed";
  }
};

export const getLieferOrt = (reservation) => {
  let Lieferaddresse = "";
  if (typeof reservation.order !== "undefined" && reservation.order !== null) {
    if (typeof reservation.order.order_addresses !== "undefined") {
      _.each(reservation.order.order_addresses, function (value, key) {
        if (value.type === "begin") {
          Lieferaddresse = value.street + " " + value.number + ", " + value.city;
        }
      });
    }
  }
  return Lieferaddresse;
};

export const printReservationContingentsAmountList = (reservation, hasFormData = false) => {
  let r = " ";
  let _description = "";
  if (!hasFormData) {
    if (typeof reservation.contingents[0] === "undefined") {
      return r;
    }

    if (typeof reservation.contingents[0] != "undefined") {
      if (reservation.contingents[0].resourcetype_id === 3 && reservation.checkins.length >= 1) {
        if (reservation.checkins[0] !== "undefined") {
          if (
            reservation.checkins[0].resource !== null &&
            reservation.checkins[0].resource !== "null"
          ) {
            return (
              <>
                <span>{t("app_order_bike_tour")}</span>
                <br />
                <span>({reservation.contingents[0].name} x 1)</span>
              </>
            );
          } else {
            if (
              reservation.contingents[0].deleted !== null &&
              reservation.contingents[0].deleted !== ""
            ) {
              return (
                <>
                  <span>{t("app_order_bike_tour")}</span>
                  <br />
                  <span>({reservation.contingents[0].name + ", " + t("contingent_removed")})</span>
                </>
              );
            } else {
              return (
                <>
                  <span>{t("app_order_bike_tour")}</span>
                  <br />
                  <span>({t("deleted_resource")})</span>
                </>
              );
            }
          }
        }
      }
    }
    if (_description !== "") {
      return _description;
    }
    let amountPerContingent = {};

    if (
      typeof reservation.contingents_reservations !== "undefined" &&
      reservation.contingents_reservations.length >= 1
    ) {
      // Client-7 reservations (where reservation.contingents_reservations holds the acutal amount,
      // however reservation.contingents has the contingent information)

      _.each(reservation.contingents_reservations, function (contingent) {
        // Get amount per contingent
        if (typeof amountPerContingent[contingent.contingent_id] === "undefined") {
          amountPerContingent[contingent.contingent_id] = contingent.amount;
        } else {
          amountPerContingent[contingent.contingent_id] += contingent.amount;
        }
      });
      let tester = {};
      _.each(amountPerContingent, function (amount, contingent_id) {
        // Get contingent data from contingents array

        let full_contingent = _.filter(reservation.contingents, function (contingent) {
          return Number(contingent.id) === Number(contingent_id);
        })[0];

        if (typeof full_contingent !== "undefined") {
          let contingentDeleted = "";

          if (
            typeof full_contingent.deleted !== "undefined" &&
            full_contingent.deleted !== null &&
            full_contingent.deleted !== ""
          ) {
            contingentDeleted =
              " (" + t("removed_${a}", { a: InboomaBaseView.prototype.t("contingent") }) + ")";
          }

          const size = FormatHelper.formatContingentTags(full_contingent.tags);
          r +=
            (r !== " " ? ", " : "") +
            full_contingent.name +
            size +
            contingentDeleted +
            " x " +
            amount;
        }
      });
    } else {
      // Regular (e.g. not-client-7) reservation
      _.each(reservation.contingents, function (contingent) {
        if (typeof contingent._joinData === "undefined") return;
        r += (r !== " " ? ", " : "") + contingent.name + " x " + contingent._joinData.amount;
      });
    }
  } else {
    let amountPerContingent = {},
      contingents = {};
    if (typeof reservation.order.reservations === undefined) {
      reservation.order.reservations = [reservation];
    }
    reservation.order.reservations.map((reservation) => {
      if (typeof reservation.contingents[0] === "undefined") {
        return;
      }
      if (typeof reservation.contingents[0] != "undefined") {
        if (reservation.contingents[0].resourcetype_id === 3 && reservation.checkins.length >= 1) {
          if (reservation.checkins[0] !== "undefined") {
            if (
              reservation.checkins[0].resource !== null &&
              reservation.checkins[0].resource !== "null"
            ) {
              _description = t("app_order_bike_tour_${a}", { a: reservation.contingents[0].name });
            } else {
              if (
                reservation.contingents[0].deleted !== null &&
                reservation.contingents[0].deleted !== ""
              ) {
                _description = t("app_order_bike_tour_min_${a}", {
                  a: reservation.contingents[0].name + ", " + t("contingent_removed"),
                });
              } else {
                _description = t("app_order_bike_tour_${a}", { a: t("deleted_resource") }); // OR: Selection of resource in app has not yet been done
              }
            }
          }
        }
      }
      if (_description !== "") {
        return _description;
      }

      if (
        typeof reservation.contingents_reservations !== "undefined" &&
        reservation.contingents_reservations.length >= 1
      ) {
        // Client-7 reservations (where reservation.contingents_reservations holds the acutal amount,
        // however reservation.contingents has the contingent information)

        _.each(reservation.contingents_reservations, function (contingent) {
          // Get amount per contingent
          let full_contingent = _.filter(reservation.contingents, function (cont) {
            return Number(cont.id) === Number(contingent.contingent_id);
          })[0];
          if (typeof full_contingent !== "undefined") {
            if (
              typeof full_contingent.deleted !== "undefined" &&
              full_contingent.deleted !== null &&
              full_contingent.deleted !== ""
            ) {
              full_contingent.contingentDeleted =
                " (" + t("removed_${a}", { a: t("contingent") }) + ")";
            }
            full_contingent.size = FormatHelper.formatContingentTags(full_contingent.tags);
            if (typeof full_contingent.size === "undefined") {
              full_contingent.size = "";
            }
            if (typeof full_contingent.contingentDeleted === "undefined") {
              full_contingent.contingentDeleted = "";
            }
            if (
              typeof amountPerContingent[
                full_contingent.name + full_contingent.size + full_contingent.contingentDeleted
              ] === "undefined"
            ) {
              amountPerContingent[
                full_contingent.name + full_contingent.size + full_contingent.contingentDeleted
              ] = contingent.amount;
            } else {
              amountPerContingent[
                full_contingent.name + full_contingent.size + full_contingent.contingentDeleted
              ] += contingent.amount;
            }

            contingents[full_contingent.name] = full_contingent;
          }
        });

        /* } else {
                     // Regular (e.g. not-client-7) reservation
                     let cont = {};
                     _.each(reservation.contingents, function(contingent) {
                         if (typeof contingent._joinData === 'undefined') return;
                         if(typeof cont[contingent.name] !== 'undefined'){
                             cont[contingent.name] += contingent._joinData.amount;
                         } else {
                             cont[contingent.name] = contingent._joinData.amount;
                         }
                     });
                     for (const [type, val] of Object.entries(cont)) {
                           r += (r !== ' '  ? ', ' : '') + type + ' x ' + val;
                     }*/
      }
    });
    _.each(amountPerContingent, function (amount, name) {
      // Get contingent data from contingents array

      if (typeof contingents !== "undefined" && typeof contingents[name] !== "undefined") {
        r +=
          (r !== " " ? ", " : "") +
          name +
          contingents[name].size +
          contingents[name].contingentDeleted +
          " x " +
          amount;
      }
    });
  }
  return r;
};

export const getEndDate = (order) => {
  let date = null;
  order.reservations.map((reservation) => {
    if (date === null) {
      date = reservation.end;
    }
    if (date !== null && reservation.end > date) {
      date = reservation.end;
    }
  });
  return date;
};
export const getAbholOrt = (reservation) => {
  let Abholaddresse = "";
  if (typeof reservation.order !== "undefined" && reservation.order !== null) {
    if (typeof reservation.order.order_addresses !== "undefined") {
      _.each(reservation.order.order_addresses, function (value, key) {
        if (value.type === "end") {
          Abholaddresse = value.street + " " + value.number + ", " + value.city;
        }
      });
    }
  }
  return Abholaddresse;
};

export const getDeliverUsername = (reservation) => {
  let Username = "";
  if (typeof reservation.order !== "undefined" && reservation.order !== null) {
    if (typeof reservation.order.order_addresses !== "undefined") {
      _.each(reservation.order.order_addresses, function (value, key) {
        if (value.type === "invoice") {
          Username = value.name;
        }
      });
    }
  }
  return Username;
};

export const getDeliverBegin = (reservation) => {
  let Begin = "";
  if (typeof reservation.order !== "undefined" && reservation.order !== null) {
    if (typeof reservation.order.order_addresses !== "undefined") {
      _.each(reservation.order.order_addresses, function (value, key) {
        if (value.type === "begin") {
          Begin = value._dateTimeBegin;
        }
      });
    }
  }
  if (Begin === "" || Begin === null) {
    Begin = reservation.begin;
  }
  return Begin;
};

export const getDeliverEnd = (reservation) => {
  let End = "";
  let lastReservation = reservation["order"]["reservations"].length - 1;
  if (typeof reservation.order !== "undefined" && reservation.order !== null) {
    if (typeof reservation.order.order_addresses !== "undefined") {
      _.each(reservation.order.order_addresses, function (value, key) {
        if (value.type === "end") {
          End = value._dateTimeEnd;
        }
      });
    }
  }
  if (End === "" || End === null) {
    End = reservation.order.reservations[lastReservation].end;
  }
  return End;
};
